import { api } from "../client";
import {
  CampaignOpportunityExtraFields,
  CampaignOpportunityFields,
  PartialCampaignOpportunityExtraFields,
  PartialCampaignOpportunityFields,
} from "../schema/CampaignOpportunity";
import { Config, ConfigMutate } from "../types";

type ApiRequestConfig = Config<
  CampaignOpportunityFields,
  CampaignOpportunityExtraFields
>;
type ApiRequestConfigMutate = ConfigMutate<
  CampaignOpportunityFields,
  CampaignOpportunityExtraFields
>;

export const getCampaignOpportunities = async (config?: ApiRequestConfig) => {
  return api.get<CampaignOpportunityFields, CampaignOpportunityExtraFields>(
    "campaign_opportunities",
    config
  );
};

export const getCampaignOpportunity = (
  id: number,
  config?: ApiRequestConfig
) => {
  return api.get<CampaignOpportunityFields, CampaignOpportunityExtraFields>(
    `campaign_opportunities/${id}`,
    config
  );
};

export const createCampaignOpportunity = (config: ApiRequestConfigMutate) => {
  return api.create<
    PartialCampaignOpportunityFields,
    PartialCampaignOpportunityExtraFields
  >("campaign_opportunities", config);
};

export const updateCampaignOpportunity = (
  id: number,
  config?: ApiRequestConfigMutate
) => {
  return api.update<
    PartialCampaignOpportunityFields,
    PartialCampaignOpportunityExtraFields
  >(`campaign_opportunities/${id}`, config);
};

export const deleteCampaignOpportunity = (id: number) => {
  return api.remove<CampaignOpportunityFields, CampaignOpportunityExtraFields>(
    `campaign_opportunities/${id}`
  );
};
